$(document).ready(function () {

    $('.wpcf7-select').prettyDropdown({
        classic: true
      });

    

    $('#prettydropdown-schulart-menu').on('click', function () {
       var selected_value = $(this).find("li.selected").attr("data-value");
       if (selected_value == 'Andere (bitte genauer ausführen)') {
           $('.wpcf7-form').find("[data-id='group-schulart']").removeClass("wpcf7cf-hidden"); 
           $('.wpcf7-form').find("[data-id='group-schulart']").show();
       } else {
            $('.wpcf7-form').find("[data-id='group-schulart']").addClass("wpcf7cf-hidden"); 
            $('.wpcf7-form').find("[data-id='group-schulart']").hide();
       }

    }); 

    $('#prettydropdown-artikel-veroeffentlicht').on('click', function () {
        var selected_value = $(this).find("li.selected").attr("data-value");
        if (selected_value == 'nein') {
            $('.wpcf7-form').find("[data-id='group-publishing']").removeClass("wpcf7cf-hidden"); 
            $('.wpcf7-form').find("[data-id='group-publishing']").show(); 
        } else {
            $('.wpcf7-form').find("[data-id='group-publishing']").addClass("wpcf7cf-hidden"); 
            $('.wpcf7-form').find("[data-id='group-publishing']").hide(); 
        }
     }); 
 
 
    $(document).on("scroll", onScroll);
    
    //smoothscroll
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll");
        
        $('a').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');
//        var headerhight = $(".header").height();
        var target = this.hash,
//            menu = target;
        $target = $(target);
        var scrollTarget = $target.offset().top - $(".header").height();
        //alert(scrollTarget);
        $('html, body').stop().animate({
            'scrollTop': scrollTarget
        }, 500, 'swing', function () {
           // window.location.hash = target;
            $(document).on("scroll", onScroll);
        });
    });

    $('.form-border').on('click', borderForm);
    $('.form-border').on('focusin', borderForm);
    
    //$('.prettydropdown ul').addClass('wpcf7-form-control wpcf7-select wpcf7-validates-as-required form-select');

    $('.wpcf7-acceptance input').addClass('form-check-input');
    $('.wpcf7-checkbox input').addClass('form-check-input');
    $('.wpcf7-radio input').addClass('form-check-input');

    
 //   $('.wpcf7-select').on('change', selectFont);
 //   $('.wpcf7-select').on('click', selectFont);

});

/*
function selectFont() {
    $(this).css({"font-family": "BundesSans"});
}*/

function onScroll(){
//    var headerPosition = $('.header').position().top;
    var scrollPos = $(document).scrollTop()+2*$(".header").height();
    
    $('#menu-homepage a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
            $('#menu-homepage ul li a').removeClass("active");
            currLink.addClass("active");
            refElement.addClass("active");
        }
        else {
            currLink.removeClass("active");
            refElement.removeClass("active");
        }
    });
/*
    if ($('#schuellerwettbewerb').position().top <= scrollPos){
        $(".header").addClass('is-pinned');   
    } else {
        $(".header").removeClass('is-pinned');   
    } */
  //  alert($('#top').position().top);
  
  
  //console.log( scrollPos );
    if (scrollPos > 280) {
       
        $(".header").addClass('is-pinned');   
    } else {
            $(".header").removeClass('is-pinned');   
        
    }     
}

function borderForm(){
    $('.form-border').removeClass('active');
    $('.form-border').removeClass('former-active');
    $(this).addClass('active');
    $(this).prevAll().addClass('former-active');    
}


/*
const el = document.querySelector(".header")
const observer = new IntersectionObserver( 
  ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  { threshold: [1] }
);

observer.observe(el); */